<template>
  <div
    v-if="headerInfo"
    class="blog-header">
    <h1 class="blog-header__title">
      {{ headerInfo.title }}
    </h1>

    <p
      v-if="headerInfo.description"
      class="blog-header__description">
      {{ headerInfo.description }}
    </p>

    <component
      :is="headerInfo.component.component"
      v-if="headerInfo.component"
      v-bind="headerInfo.component.props"
      class="blog-header__component" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ArticleStats from 'Root/pages/blog/components/ArticleStats.vue';

export default {
  name: 'BlogHeader',

  components: {
    ArticleStats,
  },

  computed: {
    ...mapState('blog', ['headerInfo']),
  },
};
</script>

<style lang="scss" scoped>
  .blog-header {
    line-height: 1.2;
  }

  .blog-header__title {
    font-size: 21px;
    font-weight: 500;
  }

  .blog-header__description {
    font-size: 15px;
    font-weight: 500;
    margin-top: 16px;
  }

  .blog-header__component {
    margin-top: 24px;
  }

  @media screen and (min-width: 768px) {
    .blog-header__title {
      font-size: 27px;
      line-height: 32px;
    }
  }

  @media screen and #{$screen-more-or-1280} {
    .blog-header__title {
      font-size: 35px;
      line-height: 41px;
    }
  }
</style>
